var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEncaissementIconsDash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.197,
    height: 80.148,
    viewBox: "0 0 80.197 80.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_354",
    x: 0,
    y: 0,
    width: 80.197,
    height: 80.148,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_358",
    x: 13.651,
    y: 27.174,
    width: 33.541,
    height: 33.542,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_359",
    x: 36.979,
    y: 36.94,
    width: 21.823,
    height: 21.815,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_360",
    x: 36.972,
    y: 29.171,
    width: 21.819,
    height: 21.774,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_361",
    x: 44.751,
    y: 36.927,
    width: 21.797,
    height: 21.823,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_362",
    x: 44.756,
    y: 29.197,
    width: 21.786,
    height: 21.774,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_268",
    "data-name": "Groupe 268",
    transform: "translate(-132.047 -230.989)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.05, 230.99)",
    filter: "url(#Trac\\xE9_354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_354-2",
    "data-name": "Trac\\xE9 354",
    d: "M181.861,256.425v-5.794c-.239-.012-.461-.032-.683-.033-2.275,0-4.55,0-6.825,0a3.882,3.882,0,0,1-4.118-4.118q-.015-2.687,0-5.372a3.879,3.879,0,0,1,4.121-4.114q9.448-.006,18.9,0a3.916,3.916,0,0,1,4.161,4.157q.014,2.655,0,5.309a3.923,3.923,0,0,1-4.181,4.138q-3.351.006-6.7,0H185.8v5.828h.71c1.875,0,3.75,0,5.625,0a5.827,5.827,0,0,1,5.921,4.764q2.533,11.784,5.048,23.572a6.184,6.184,0,0,1,.126,1.252q.018,3.475.005,6.952a5.865,5.865,0,0,1-6.2,6.17q-24.868,0-49.738,0a5.874,5.874,0,0,1-6.209-6.229c0-1.137.051-2.278-.011-3.412a30.587,30.587,0,0,1,.9-8.374c1.472-6.59,2.857-13.2,4.267-19.8a5.842,5.842,0,0,1,6-4.893q14.411,0,28.82,0Zm-36.4,27.141h53.378a3.773,3.773,0,0,0-.039-.409q-2.22-10.362-4.447-20.725c-.377-1.752-.876-2.134-2.7-2.134H172.887q-10.2,0-20.408,0c-1.56,0-2.137.465-2.458,1.958q-1.87,8.7-3.739,17.393C146,280.941,145.737,282.235,145.457,283.566Zm-.472,3.957v5.255c0,1.8.67,2.468,2.476,2.468h49.4c.169,0,.337,0,.506,0a1.941,1.941,0,0,0,1.974-2.017c.013-1.579,0-3.159,0-4.738v-.966ZM174.13,246.66h19.346v-5.73H174.13Z",
    transform: "translate(-132.05 -230.99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.05, 230.99)",
    filter: "url(#Trac\\xE9_358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_358-2",
    "data-name": "Trac\\xE9 358",
    d: "M162.419,279.7c-1.875,0-3.75,0-5.624,0a1.916,1.916,0,0,1-2.091-2.075q-.012-5.688,0-11.375a1.928,1.928,0,0,1,2.042-2.077q5.718-.024,11.438,0a1.927,1.927,0,0,1,2.04,2.026q.03,5.751,0,11.5a1.912,1.912,0,0,1-2.053,2C166.253,279.709,164.336,279.7,162.419,279.7Zm3.881-3.912v-7.7h-7.676v7.7Z",
    transform: "translate(-132.05 -230.99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.05, 230.99)",
    filter: "url(#Trac\\xE9_359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_359-2",
    "data-name": "Trac\\xE9 359",
    d: "M181.848,273.929v3.815h-3.823v-3.815Z",
    transform: "translate(-132.05 -230.99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.05, 230.99)",
    filter: "url(#Trac\\xE9_360)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_360-2",
    "data-name": "Trac\\xE9 360",
    d: "M178.018,266.16h3.819v3.774h-3.819Z",
    transform: "translate(-132.05 -230.99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.05, 230.99)",
    filter: "url(#Trac\\xE9_361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_361-2",
    "data-name": "Trac\\xE9 361",
    d: "M185.8,273.916h3.8v3.823h-3.8Z",
    transform: "translate(-132.05 -230.99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.05, 230.99)",
    filter: "url(#Trac\\xE9_362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_362-2",
    "data-name": "Trac\\xE9 362",
    d: "M189.589,269.96H185.8v-3.774h3.786Z",
    transform: "translate(-132.05 -230.99)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncaissementIconsDash);
export default __webpack_public_path__ + "static/media/encaissement-icons-dash.cc530a9bdcd3fba8baa74eb4f573d37b.svg";
export { ForwardRef as ReactComponent };